// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const listRunsApiAiRunsGetParamsSortDefault = `created_at`;
export const listRunsApiAiRunsGetParamsSortMax = 40;

export const listRunsApiAiRunsGetParamsOrderDefault = `desc`;
export const listRunsApiAiRunsGetParamsPageDefault = 1;

export const listRunsApiAiRunsGetParamsPageSizeDefault = 50;
export const listRunsApiAiRunsGetParamsPageSizeMax = 200;

export const listRunsApiAiRunsGetParamsProcessItemMax = 120;

export const listRunsApiAiRunsGetParamsProcessDefault = [];
export const listRunsApiAiRunsGetParamsProcessMax = 50;

export const listRunsApiAiRunsGetParamsModelItemMax = 120;

export const listRunsApiAiRunsGetParamsModelDefault = [];
export const listRunsApiAiRunsGetParamsModelMax = 50;

export const listRunsApiAiRunsGetParamsUserItemMax = 120;

export const listRunsApiAiRunsGetParamsUserDefault = [];
export const listRunsApiAiRunsGetParamsUserMax = 50;

export const listRunsApiAiRunsGetParamsStatusItemMax = 40;

export const listRunsApiAiRunsGetParamsStatusDefault = [];
export const listRunsApiAiRunsGetParamsStatusMax = 50;

export const listRunsApiAiRunsGetParamsCostMinOneMin = 0;
export const listRunsApiAiRunsGetParamsCostMinOneMax = 1000000;

export const listRunsApiAiRunsGetParamsCostMaxOneMin = 0;
export const listRunsApiAiRunsGetParamsCostMaxOneMax = 1000000;

export const listRunsApiAiRunsGetParamsLatencyMinMsOneMin = 0;

export const listRunsApiAiRunsGetParamsLatencyMaxMsOneMin = 0;

export const listRunsApiAiRunsGetParamsMonthOneMax = 7;

export const listRunsApiAiRunsGetParamsYearOneMax = 4;

export const ListRunsApiAiRunsGetParams = zod.object({
  "sort": zod.string().max(listRunsApiAiRunsGetParamsSortMax).default(listRunsApiAiRunsGetParamsSortDefault),
  "order": zod.enum(['asc', 'desc']).default(listRunsApiAiRunsGetParamsOrderDefault),
  "page": zod.int().min(1).default(listRunsApiAiRunsGetParamsPageDefault),
  "page_size": zod.int().min(1).max(listRunsApiAiRunsGetParamsPageSizeMax).default(listRunsApiAiRunsGetParamsPageSizeDefault),
  "process": zod.array(zod.string().max(listRunsApiAiRunsGetParamsProcessItemMax)).max(listRunsApiAiRunsGetParamsProcessMax).default(listRunsApiAiRunsGetParamsProcessDefault),
  "model": zod.array(zod.string().max(listRunsApiAiRunsGetParamsModelItemMax)).max(listRunsApiAiRunsGetParamsModelMax).default(listRunsApiAiRunsGetParamsModelDefault),
  "user": zod.array(zod.string().max(listRunsApiAiRunsGetParamsUserItemMax)).max(listRunsApiAiRunsGetParamsUserMax).default(listRunsApiAiRunsGetParamsUserDefault),
  "status": zod.array(zod.string().max(listRunsApiAiRunsGetParamsStatusItemMax)).max(listRunsApiAiRunsGetParamsStatusMax).default(listRunsApiAiRunsGetParamsStatusDefault),
  "created_from": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "created_to": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "cost_min": zod.union([zod.number().min(listRunsApiAiRunsGetParamsCostMinOneMin).max(listRunsApiAiRunsGetParamsCostMinOneMax),zod.string(),zod.null()]).optional(),
  "cost_max": zod.union([zod.number().min(listRunsApiAiRunsGetParamsCostMaxOneMin).max(listRunsApiAiRunsGetParamsCostMaxOneMax),zod.string(),zod.null()]).optional(),
  "latency_min_ms": zod.union([zod.int().min(listRunsApiAiRunsGetParamsLatencyMinMsOneMin),zod.null()]).optional(),
  "latency_max_ms": zod.union([zod.int().min(listRunsApiAiRunsGetParamsLatencyMaxMsOneMin),zod.null()]).optional(),
  "month": zod.union([zod.string().max(listRunsApiAiRunsGetParamsMonthOneMax),zod.null()]).optional(),
  "year": zod.union([zod.string().max(listRunsApiAiRunsGetParamsYearOneMax),zod.null()]).optional()
})

export type ListRunsApiAiRunsGetParams = zod.input<typeof ListRunsApiAiRunsGetParams>;
export type ListRunsApiAiRunsGetParamsOutput = zod.output<typeof ListRunsApiAiRunsGetParams>;
